module.exports = __webpack_public_path__ + "static/img/shangqi.d2ea71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/shangqi.png
// module id = HWOL
// module chunks = 2